import { Card, CardBody, Col, Row } from "reactstrap";

import AssessmentTimerCard from "../../../../container/AssessmentTimer";
import { Question } from "../../../../utils/Constant";
import { questionTypes } from "../../../../utils/helper/helper";
import useIsMobile from "../../../../utils/helper/responsive";
import {
  getFromSessionStorage,
  QUESTION_PREVIEW_DATA,
} from "../../../../utils/helper/sessionStorageUtils";
import Header from "../../../LearningAssessment/Header";
import DatePicker from "../../../LearningAssessment/Questions/DatePicker";
import Dropdown from "../../../LearningAssessment/Questions/Dropdown";
import FreeText from "../../../LearningAssessment/Questions/FreeText";
import LikertScale from "../../../LearningAssessment/Questions/LikertScale";
import MatchTheFollowing from "../../../LearningAssessment/Questions/MatchTheFollowing";
import MultiChoise from "../../../LearningAssessment/Questions/MultiChoise";
import Rating from "../../../LearningAssessment/Questions/Rating";
import Sequencing from "../../../LearningAssessment/Questions/Sequencing";
import SingleChoise from "../../../LearningAssessment/Questions/SingleChoise";

const QuestionPreview = () => {
  const question = getFromSessionStorage(QUESTION_PREVIEW_DATA);
  const isMobile = useIsMobile();

  const renderQuestionComponent = (questionNumber: string) => {
    const question_text = question?.question_text;
    const question_type = question?.question_type;
    const options = question?.options;

    switch (question_type) {
      case questionTypes.multi_select:
        return (
          <MultiChoise
            questionId={question.question_id}
            title={question_text}
            questionNumber={questionNumber}
            options={options}
            handleChange={() => null}
            mediaUrl={question.media_url}
            isChecked={() => null}
            extension={question.extension}
            fileName={question.fileName}
          />
        );

      case questionTypes.single_select:
        return (
          <SingleChoise
            questionId={question.question_id}
            title={question_text}
            questionNumber={questionNumber}
            options={options}
            handleChange={() => null}
            mediaUrl={question.media_url}
            isChecked={() => null}
            extension={question.extension}
            fileName={question.fileName}
          />
        );

      case questionTypes.open_text:
        return (
          <FreeText
            questionId={question.question_id}
            title={question_text}
            questionNumber={questionNumber}
            handleChange={() => null}
            mediaUrl={question.media_url}
            extension={question.extension}
            fileName={question.fileName}
          />
        );

      case questionTypes.match_the_following: {
        // Transform options to expected structure
        let transformedOptions = [];
        if (
          Array.isArray(options) &&
          options.length > 0 &&
          options[0].left !== undefined &&
          options[0].right !== undefined
        ) {
          // Flatten left and right into separate objects with match_side
          transformedOptions = [
            ...options.map(opt => ({
              option_id: opt.option_id * 2 + 1, // Generate unique id for left
              option_text: opt.left,
              match_side: "left",
            })),
            ...options.map(opt => ({
              option_id: opt.option_id * 2 + 2, // Generate unique id for right
              option_text: opt.right,
              match_side: "right",
            })),
          ];
        } else {
          transformedOptions = options;
        }
        const transformedQuestion = {
          ...question,
          options: transformedOptions,
        };
        return (
          <MatchTheFollowing
            question={transformedQuestion}
            onAnswerChange={() => null}
            savedAnswer={null}
            questionNumber={questionNumber}
            mediaUrl={question.media_url}
          />
        );
      }

      case questionTypes.ranking:
        return (
          <Sequencing
            question={question}
            onAnswerChange={() => null}
            savedAnswer={null}
            questionNumber={questionNumber}
            mediaUrl={question.media_url}
          />
        );

      case questionTypes.rating:
        return (
          <Rating
            questionId={question.question_id}
            title={question_text}
            questionNumber={questionNumber}
            options={options}
            handleChange={() => null}
            isChecked={() => false}
            mediaUrl={question.media_url}
          />
        );

      case questionTypes.likert_scale:
        return (
          <LikertScale
            questionId={question.question_id}
            title={question_text}
            questionNumber={questionNumber}
            options={options}
            handleChange={() => null}
            isChecked={() => false}
            mediaUrl={question.media_url}
          />
        );

      case questionTypes.dropdown:
        return (
          <Dropdown
            questionId={question.question_id}
            title={question_text}
            questionNumber={questionNumber}
            options={options}
            handleChange={() => null}
            isChecked={() => false}
            mediaUrl={question.media_url}
          />
        );

      case questionTypes.date_picker:
        return (
          <DatePicker
            questionId={question.question_id}
            title={question_text}
            questionNumber={questionNumber}
            handleChange={() => null}
            value={""}
            mediaUrl={question.media_url}
          />
        );

      default:
        return null;
    }
  };

  return (
    <div>
      <Header name={question?.name} />
      <Row className="learning-assessment justify-content-center">
        {isMobile && (
          <Col xs="12">
            <AssessmentTimerCard
              time={{
                hours: 0,
                minutes: 0,
                seconds: 0,
              }}
            />
          </Col>
        )}
        <Col xs="12" md="7" className="mb-4">
          <Card>
            <CardBody>{renderQuestionComponent(`${Question} 1`)}</CardBody>
          </Card>
        </Col>
        {!isMobile && (
          <Col xs="12" md="4">
            <AssessmentTimerCard
              time={{
                hours: 0,
                minutes: 0,
                seconds: 0,
              }}
            />
          </Col>
        )}
      </Row>
    </div>
  );
};

export default QuestionPreview;
